let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dQMD4")).then(() => parcelRequire('jcm12'));